<template>
  <div>
    <b-modal
      v-model="showModal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      @hidden="close()"
    >
      <div class="text-center p-4">
        <div class="d-block text-center mb-4">
          <img src="@/assets/images/icons/warning.png" alt="warning" width="70" class="mb-4" />
          <h3>ยังไม่ได้เชื่อม Facebook Page</h3>
          <p>กรุณาเชื่อม Facebook Page ก่อนใช้งานเมนู Live</p>
        </div>
        <b-button class="px-5" @click="goSettingPage" variant="main"
          >ไปยังหน้าเชื่อม Facebook Page</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    goSettingPage() {
      this.$router.push({ path: `/setting` }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
</style>
